import {
    ILoyaltyUserAuth,
    IUserAuthStates,
    IFormattedAuthResult
} from '~api/interfaces/ILoyaltyUserAuth';

export const FormatUserAuthData = (userAuthData: ILoyaltyUserAuth, authStates: IUserAuthStates) => {
    const { user } = userAuthData;
    const { signedIn, recognized, loyaltyActiveFlag } = user;
    let userAuthState: string = authStates.RECOGNIZED;

    if (signedIn === true) {
        userAuthState = authStates.SIGNEDIN;
    } else if (recognized === null || recognized === false) {
        userAuthState = authStates.ANONYMOUS;
    }

    return { authState: userAuthState, hasLoyalty: loyaltyActiveFlag } as IFormattedAuthResult;
};
